
  import {computed, defineComponent, inject, PropType} from "vue";
  import Customer from "@/model/Customer";
  import CustomerDetailsCardContact from "./CustomerDetailsCardContact.vue";
  import CustomerDetailsCardSpecificInformation from "./CustomerDetailsCardSpecificInformation.vue";
  import CustomerDetailsCardGeneralInformation from "./CustomerDetailsCardGeneralInformation.vue";
  import CustomerDetailsCardTravelTimes from "./CustomerDetailsCardTravelTimes.vue";
  import {OrderType} from "@/enums";
  import {isAuthorized, t} from "@/mixin/mixins";
  import CustomerServiceV2 from "@/service/CustomerServiceV2";
  import eventBus from "@/eventbus";
  import {MessageTypes} from "@/components/message-types";

  export default defineComponent({
    name: "CustomerDetailsInfo",
    components: {
      CustomerDetailsCardContact,
      CustomerDetailsCardSpecificInformation,
      CustomerDetailsCardGeneralInformation,
      CustomerDetailsCardTravelTimes
    },
    props: {
      customer: {
        type: Object as PropType<Customer>,
        default: () => new Customer(),
      },
      customerTypes: {
        type: Array as PropType<Array<OrderType>>,
        default: () => new Array<OrderType>()
      }
    },
    setup (props, context) {

      let appRoot = inject("app-root");
      // @ts-ignore
      const confirmDialog = appRoot.confirmDialogComposition as InstanceType<typeof ConfirmDialogComposition>;

      const editable = computed(() => {
        return props.customer?.active && isAuthorized("Customer_Update");
      });

      const deleteCustomer = () => {
        const uuid = props.customer.uuid;
        if (!uuid) {
          return;
        }
        const title = t("customer.confirmDelete.title");
        const text = t("customer.confirmDelete.text");
        confirmDialog.open(title, text)
          .then((confirmResult: boolean) => {
            if (confirmResult) {
              CustomerServiceV2.deactivateCustomer(uuid)
                .then(() => {
                  eventBus.$emit(MessageTypes.CUSTOMER_DELETED);
                })
                .catch(error => {
                  // An already inactive customer gets a 409, which the global error handler already shows. Reload it
                  // anyway, so the details show it as inactive.
                  if (error?.response?.status === 409) {
                    eventBus.$emit(MessageTypes.CUSTOMER_DELETED);
                  }
                });
            }
          });
      };

      return {
        deleteCustomer,
        editable
      };
    }});
